import request from "@/utils/request";

export async function isQuestioned(params) {
  return request({
    url: "/sCenter/question/exist",
    method: "GET",
    params,
  });
}

export async function getQuestionList(params) {
  return request({
    url: "/sCenter/question/list",
    method: "GET",
    params,
  });
}
export async function questionSave(data) {
  return request({
    url: "/sCenter/question/save",
    method: "POST",
    data,
  });
}

export async function questionAnswer(data) {
  return request({
    url: "/sCenter/question/answer",
    method: "POST",
    data,
  });
}

export async function getQuestionInfo(id) {
  return request({
    url: "/sCenter/question/detail",
    method: "GET",
    params: {
      id,
    },
  });
}

export async function putQuestionExtData(data) {
  return request({
    url: "/sCenter/question/extData",
    method: "PUT",
    data,
  });
}

export async function getQuestionMsg(params) {
  return request({
    url: "/sCenter/question/unread",
    method: "GET",
    params,
  });
}

export async function questionRead(id) {
  return request({
    url: "/sCenter/question/read",
    method: "PUT",
    data: {
      id,
    },
  });
}
export async function getQuestionUnread(questionId) {
  return request({
    url: "/sCenter/question/isRead",
    method: "GET",
    params: {
      questionId,
    },
  });
}

export async function solveQuestion(ticketId) {
  return request({
    url: "/sCenter/question/ticket/solved",
    method: "POST",
    data: {
      ticketId,
    },
  });
}
